const Backbone              = window.Backbone;
const url                   = window.url;
const routes                = window.routes;
const windowText            = window.text;
const featureManager        = window.featureManager;

const TitleSeries = Backbone.View.extend({

    initialize({hideSubtitle}) {
        this.useEnhancedSeries = featureManager.isEnabled('enhancedSeries') && (typeof this.model.get('detailedSeries') !== 'undefined');
        this.hideSubtitle = hideSubtitle;

        this.listenTo(this.model, 'update', this.render);
        this.render();
    },

    render() {
        let searchParams = this.useEnhancedSeries
                            ? {type: 'seriesId', query: this.model.get('detailedSeries').seriesId, sortBy: 'readingOrder'}
                            : { type: 'series', query: this.model.get('series'), sortBy: 'newlyadded'};


        let subtitleContainsSeries =  this.model.get('subtitle') && this.model.get('subtitle').indexOf(this.model.get('series')) > -1;

        let seriesText = '';
        if (this.useEnhancedSeries){
            let detailedSeries = this.model.get('detailedSeries');

            let formattedReadingOrder = (detailedSeries.readingOrder % 1) === 0 ? detailedSeries.readingOrder.toFixed(0) : detailedSeries.readingOrder.toFixed(1);
            seriesText = window.text('enhancedSeriesLink', { seriesName: detailedSeries.seriesName, readingOrder: formattedReadingOrder});
        } else {
            seriesText = subtitleContainsSeries  ? this.model.get('subtitle') : (this.model.get('series') || '');

        }

        if (this.model.get('type').id === 'magazine'){
            searchParams.mediaType = 'magazine';
        }

        let viewModel = {
            id          : this.model.get('id'),
            title       : this.model.get('title'),
            series      : seriesText,
            subtitle    : this.model.get('subtitle') || '',
            searchUrl   : url(routes.searchByType, searchParams),
            language    : _.first(this.model.get('languages') || ['']),
            noCreators : _.isEmpty(this.model.get('creators'))
        };

        let $temp = $(document.createDocumentFragment());

        if (!this.hideSubtitle && !subtitleContainsSeries && !_.isEmpty(viewModel.subtitle)) {
            let $subtitle   = this._buildSubtitle(viewModel.subtitle, viewModel.language);
            $temp.append($subtitle);
        }

        if (!_.isEmpty(viewModel.series)) {
            let $series  = this._buildSeriesLink(viewModel.searchUrl, viewModel.noCreators, viewModel.series);
            $temp.append($series);
        }

        this.$el.html($temp);
    },

    _buildSeriesLink(searchUrl, noCreators, text) {

        let $elm = $('<p />', { 'class': `series ${noCreators ? 'no-author' : ''}` });

        let $link = $('<a />', {
            'aria-label': windowText('cover.searchBySeries', { series: text }),
            'class'     :'series-link secondary-hover-underline',
            'href'      : searchUrl,
            'title'     : text,
            text
        });

        $elm.append($link);

        return $elm;
    },

    _buildSubtitle(subtitle, language) {
        return $('<p />', {
            'class' : 'subtitle',
            'text'  : subtitle,
            'lang'  : language
        });
    }
});

module.exports = TitleSeries;
